import Vue from 'vue';
import { mapMutations, mapState } from 'vuex';
export default Vue.extend({
    name: 'App',
    provide() {
        return {
            reload: this.reload,
            checkUrl: this.checkUrl,
            mapUrl: this.mapUrl
        };
    },
    data() {
        return {
            isRouterAlive: true
        };
    },
    computed: {
        ...mapState('common', ['lang', 'dialog', 'overlay']),
        ...mapState('auth', ['token', 'loginUser', 'isLogin']),
        ...mapState('news', ['sourceTargetKey']),
        windowSizeName() {
            return this.$vuetify.breakpoint.name;
        }
    },
    watch: {
        'dialog.name'(newVal, oldVal) {
            if (oldVal === 'Logout' && this.loginUser.flag === 2) {
                this.init();
            }
        },
        isLogin(newVal) {
            if (newVal) {
                this.init();
            }
        },
        lang: function (newVal) {
            this.$i18n.locale = newVal;
            localStorage.setItem('footmarkLang', newVal);
        },
        token: function (newVal, oldVal) {
            if (newVal !== oldVal && !newVal) {
                if (this.$router.currentRoute.path !== '/') {
                    // this.$router.push({ path: '/' }).catch(err => {
                    //   if (err.name !== 'NavigationDuplicated') {
                    //     throw err
                    //   }
                    // })
                }
            }
        }
    },
    created() {
        this.init();
    },
    methods: {
        ...mapMutations('common', ['ChangeState', 'ChangeDialog']),
        reload() {
            this.isRouterAlive = false;
            this.$nextTick(() => {
                this.isRouterAlive = true;
            });
        },
        init() {
            if (this.loginUser.flag === 2) {
                this.ChangeDialog('SetPassword');
            }
            const footmarkLang = localStorage.getItem('footmarkLang');
            if (footmarkLang) {
                const data = {
                    key: 'lang',
                    val: footmarkLang
                };
                this.ChangeState(data);
            }
        },
        mapUrl(fileName, key) {
            let url = '';
            if (fileName) {
                url = this.sourceTargetKey;
                if (['introduce', 'source', 'psd'].includes(key)) {
                    url += 'news/' + fileName;
                }
                else if (['special'].includes(key)) {
                    url += 'special/' + this.loginUser.pid.toUpperCase() + '_' + fileName;
                }
            }
            return url;
        },
        checkUrl(url) {
            if (!url) {
                return false;
            }
            let xmlhttp;
            if (window.XMLHttpRequest) {
                xmlhttp = new XMLHttpRequest();
            }
            else {
                // xmlhttp = new ActiveXObject('Microsoft.XMLHTTP')
            }
            xmlhttp.open('GET', url, false);
            xmlhttp.send();
            if (xmlhttp.readyState === 4) {
                const res = xmlhttp.responseText;
                switch (xmlhttp.status) {
                    case 200:
                        if (res.indexOf('<!DOCTYPE html>') !== -1) {
                            return '';
                        }
                        else {
                            return url;
                        }
                    case 404:
                        return '';
                }
            }
            else {
                return '';
            }
        }
    }
});
